import React, { useState, useEffect, useRef } from 'react';
import { useFoodOrderSocket } from '../utils/useSocket';
import services from 'API/services';
import { toast } from "react-toastify";
import { useSelector, useDispatch } from 'react-redux';
import { authenticationSeletor } from "../store/slices/authenticationSlice";
import { createKotLogs } from "../store/slices/PropertyData";

const NotificationPopup = ({ propertyId }) => {

  const dispatch = useDispatch()
  const [order, setOrder] = useState(null);
  const audioRef = useRef(null);
  const { userDetail } = useSelector(authenticationSeletor);
  const [condition, setCondition] = useState('')

  useEffect(() => {
    const unlockAudio = () => {
      if (audioRef?.current) {
        audioRef?.current.play().catch(() => { });
      }
      window.removeEventListener("click", unlockAudio);
    };
    window.addEventListener("click", unlockAudio);
    return () => window.removeEventListener("click", unlockAudio);
  }, []);


  useFoodOrderSocket(
    propertyId,
    // 1. New Order
    (order) => {

      if (order.type === "NEW_ORDER") {
        if (userDetail?.role == 15 || userDetail?.role == 22 || userDetail?.role == 27) {
          setOrder(order.data);
          setCondition(order.type);
        }
      }
    },

    // 2. Accept/Reject
    (orderId, status) => {
      setOrder((prevOrder) => {
        if (prevOrder?.id === orderId) {
          return null; // hide
        }
        return prevOrder;
      });
    },

    // 3. Ready
    (order) => {
      if (order.type == "ORDER_READY") {
        if (userDetail?.role == 23 || userDetail?.role == 28) {
          setOrder(order.data);
          setCondition(order.type);
        }
      }

    },

    // 4. Delivered
    (order) => {
      if (order.type === "ORDER_DELIVERED") {
        setOrder(null);
        setCondition(order.type);
      }
    }
  );

  useEffect(() => {
    if (order && audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((err) =>
        console.warn("Audio play error:", err)
      );
    }
  }, [order]);

  const [newOrderItems, setNewOrderItems] = useState([])
  useEffect(() => {
    if (order?.orderItems) {
      setNewOrderItems(JSON.parse(order.orderItems))
    }
  }, [order])

  const changeStatus = async ({ id }, status) => {
    try {
      const realPayload = {
        order_status: status,
        acceptedBy: userDetail?.id
      };
      const res = await services.property.updateFoodOrderStatus(realPayload, id);
      if (res.status == 200) {
        if (status == 1) {
          toast.success('Food Order Accepted Successfull', {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
        }
        if (status == 3) {
          toast.success('Food Order Confirmed', {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
          setOrder(null)
        }
        if (status == 4) {
          toast.error('Food Order Rejected', {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
        }
        const params = {
          action: `KOT ${(status == 1 && 'accepted') || (status == 3 && 'Confirmed') || (status == 4 && 'Rejected')} by ${userDetail?.name}`,
          actionBy: userDetail?.name,
          operation: `KOT ${(status == 1 && 'accepted') || (status == 3 && 'Confirmed') || (status == 4 && 'Rejected')}`,
          propertyId: userDetail?.propertyId,
          bookingCode: 'id'
        }
        dispatch(createKotLogs(params));

      }
    } catch (error) {
    }
  };

  if (!order) return null;

  return (
    <div className="kot-popup">
      <div className='kot-popup-content'>
        <audio ref={audioRef} src="/notification.mp3" loop  />
        <h5 className='text-center pb-5'>Order Details</h5>
        <div className='flex justify-content-between pb-2'>
          <h6>Order Id</h6>
          <p>#{order?.id}</p>
        </div>
        <div className='flex justify-content-between pb-2'>
          <h6>KOT Type</h6>
          <p>{order?.ncType}</p>
        </div>
        {
          order?.otherGuestName &&
          <div className='flex justify-content-between pb-2'>
            <h6>Guest</h6>
            <p>{order?.otherGuestName}</p>
          </div>
        }
        {
          order?.roomNumber &&
          <div className='flex justify-content-between pb-2'>
            <h6>Room</h6>
            <p>{order?.roomNumber}</p>
          </div>
        }
        <div className='order-list flex'>
          {
            newOrderItems?.map((item, idx) => {
              return (
                <div className='column'>
                  <span className='name'>{item?.name}</span>
                  <span className='qty'>{item?.qty}</span>
                  <span className='price'>₹{item?.price}</span>
                </div>
              )
            })
          }
        </div>
        {
          order?.remark &&
          <div className='flex justify-content-between mt-2'>
            <p className='fs-8'>Note - {order?.remark}</p>
          </div>
        }
        <div className='flex justify-content-between align-items-center bg-light p-2 rounded-1 mt-4'>
          <h6>Amount</h6>
          <p>₹ {order?.orderAmount}</p>
        </div>
        <div className='text-center pt-4'>
          {
            condition != "ORDER_READY" ?
              <>
                <button
                  className="btn btn-success btn-sm mr-2"
                  onClick={() => changeStatus(order, 1)}
                >
                  Accept Order
                </button>

                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => changeStatus(order, 4)}
                >
                  Reject Order
                </button>
              </> : <button
                className="btn btn-success btn-sm mr-2"
                onClick={() => changeStatus(order, 3)}
              >
                Confirm Pickup
              </button>
          }
        </div>

      </div>
    </div>
  );
};

export default NotificationPopup;
